import { render, staticRenderFns } from "./OccupationSelectionForm.vue?vue&type=template&id=c77fe4e4&scoped=true&"
import script from "./OccupationSelectionForm.vue?vue&type=script&lang=ts&"
export * from "./OccupationSelectionForm.vue?vue&type=script&lang=ts&"
import style0 from "./OccupationSelectionForm.vue?vue&type=style&index=0&id=c77fe4e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77fe4e4",
  null
  
)

export default component.exports